import { Button, Icon, ProgressBar, Spinner } from "@blueprintjs/core";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import React, { useState } from "react";
import { useDropzone } from "react-dropzone";
import { useNavigate } from "react-router-dom";
import { v4 as uuid } from "uuid";
import { storage } from "../firebase";
import { AppToaster } from "./Toaster";

const section = {
  maxWidth: "800px",
  margin: "auto",
};

const container = {
  position: "relative",
  padding: "10px",
  margin: "auto",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  color: "#FFFFFF",
  background: "#ffff",
  minHeight: "300px",
  flexDirection: "column",
  borderRadius: "4px",
};

const fileContainer = {
  width: "100%",
  marginBottom: "65px",
  maxHeight: "500px",
  overflowX: "hidden",
  overflowY: "auto",
};

const innerContainer = {
  width: "100%",
  position: "absolute",
  bottom: "0",
  left: "0",
  padding: "10px",
  borderTop: "1px solid #6060606e",
  cursor: "pointer",
};

function InnerDropzone({ files, unique_id, setFiles, progress }) {
  console.log("files", files);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      let currentFileDrop = [...files];
      acceptedFiles.map((file, index) => {
        currentFileDrop.push(
          Object.assign(file, { progress: 0 }, { id: unique_id + index })
        );
      });

      console.log("currentFileDrop", currentFileDrop);

      setFiles(currentFileDrop);
    },
  });

  return (
    <div {...getRootProps({ className: "dropzone" })} style={innerContainer}>
      <input {...getInputProps()} />

      {progress > 0 ? (
        <ProgressBar
          intent={getIntentProgress(progress)}
          value={getValueProgress(progress)}
          animate={getAnimateProgress(progress)}
          stripes={getAnimateProgress(progress)}
        />
      ) : (
        <p style={{ color: "black", textAlign: "center", margin: "0" }}>
          Drag 'n' drop some files here, or{" "}
          <span
            className="bp4-intent-primary"
            style={{ textDecoration: "underline" }}
          >
            click
          </span>{" "}
          to select files
        </p>
      )}
    </div>
  );
}

function getIntentProgress(progress) {
  if (progress == 100) {
    return "success";
  }

  return "primary";
}

function getAnimateProgress(progress) {
  if (progress === 100) return false;

  return true;
}

function getValueProgress(progress) {
  if (progress === 0) return 0;

  var convert = progress.toString();
  if (convert.length === 1) {
    return 0.1;
  } else if (convert.length === 2) {
    var divideNumber = progress / 10;
    return parseFloat("0." + divideNumber.toString());
  }

  return 1;
}

function Dropzone({ files, setFiles, setUrlDownload }) {
  const [progressFirebase, setProgressFirebase] = useState(0);
  const [progressZip, setProgressZip] = useState(0);
  const unique_id = uuid();

  const navigate = useNavigate();

  const { getRootProps, getInputProps, isDragAccept } = useDropzone({
    noClick: true,
    onDrop: (acceptedFiles) => {
      let currentFileDrop = [...files];
      acceptedFiles.map((file, index) => {
        currentFileDrop.push(
          Object.assign(file, { progress: 0 }, { id: unique_id + index })
        );
      });

      setFiles(currentFileDrop);
    },
  });

  const thumbs = files.map((file, index) => {
    return (
      <li key={file.name + index} id={file.id}>
        <div
          className="text-placeholder"
          style={{ color: "black", width: "100%" }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "5px",
              alignItems: "center",
            }}
          >
            <span
              className="bp4-text-overflow-ellipsis"
              style={{ width: "40%", textAlign: "left" }}
              title={file.name}
            >
              {file.name}
            </span>

            <span
              className="bp4-text-overflow-ellipsis"
              style={{ width: "20%", textAlign: "center" }}
            >
              {Math.round(file.size / 1024) + "KB "}
            </span>
            <span
              className="bp4-text-overflow-ellipsis"
              style={{ width: "30%", textAlign: "left" }}
            >
              {file.type}
            </span>
            <span style={{ width: "10%", textAlign: "center" }}>
              <Button
                onClick={() => deleteFile(file.id)}
                icon="cross"
                minimal={true}
                intent={"danger"}
              />
            </span>
          </div>

          <div className="bp4-menu-divider"></div>
        </div>
      </li>
    );
  });

  function deleteFile(id) {
    const newFiles = files.filter((file) => file.id !== id);
    setFiles(newFiles);
  }

  function uploadFile() {
    const zip = require("jszip")();

    files?.map((file) => {
      zip.file(file.name, file);
    });

    zip
      .generateAsync(
        {
          type: "blob",
          compression: "DEFLATE",
          compressionOptions: {
            level: 6,
          },
          streamFiles: true,
        },
        function updateCallback(metadata) {
          setProgressZip(metadata.percent.toFixed(0));
        }
      )
      .then((content) => {
        const storageRef = ref(storage, `/file/${unique_id}.zip`);
        const uploadTask = uploadBytesResumable(storageRef, content);

        uploadTask.on(
          "state_changed",
          (snapshot) => {
            const prog = Math.round(
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            );

            switch (snapshot.state) {
              case "paused":
                //console.log("Upload is paused");
                break;
              case "running":
                //console.log("Upload is running");
                break;
            }

            setProgressFirebase(prog);

            /* const indexFile = files.findIndex((ele) => ele.id === file.id);

          const currentFiles = [...files];
          currentFiles[indexFile].progress = prog;

          setFiles(currentFiles); */
          },
          (error) => {
            switch (error.code) {
              case "storage/unauthorized":
                // User doesn't have permission to access the object
                console.log("FINISH FIREBASE");
                break;
              case "storage/canceled":
                console.log("User canceled the upload");
                // User canceled the upload
                console.log("FINISH FIREBASE");
                break;

              // ...

              case "storage/unknown":
                // Unknown error occurred, inspect error.serverResponse
                break;
            }
          },
          () => {
            getDownloadURL(uploadTask.snapshot.ref).then((url) =>
              setUrlDownload(url)
            );
            AppToaster.show({
              message: "Upload is success!",
              intent: "success",
            });

            console.log("FINISH FIREBASE");

            //use navigate
            setTimeout(() => {
              navigate("/send");
            }, 2400);
          }
        );
      })
      .then((finish) => {
        console.log("FINISH ZIP");
      });
  }

  return (
    <section style={section}>
      <div
        style={{
          border: "2px dashed #FFFFFF",
          borderRadius: "4px",
          padding: "20px",
        }}
      >
        <div
          {...getRootProps({
            className: "dropzone",
            isDragAccept,
          })}
          style={container}
        >
          <input {...getInputProps()} />

          {!files.length > 0 && (
            <Icon
              style={{
                position: "absolute",
                top: "50%",
                transform: `translateY(-65%) scale(${
                  isDragAccept ? "1.3" : "1"
                })`,
                color: "#d3d3d3",
                transition: "transform .14s ease-in-out",
              }}
              icon="cloud-upload"
              size={80}
            />
          )}

          <aside style={fileContainer}>
            {progressZip > 0 && progressZip != 100 ? (
              <div className="disabledbutton">
                <Spinner
                  intent={getIntentProgress(progressZip)}
                  value={getValueProgress(progressZip)}
                  size={100}
                />
                <div
                  style={{
                    position: "absolute",
                    left: "50%",
                    top: "70%",
                    transform: "translate(-50%, -65%)",
                    color: "black",
                  }}
                >
                  file compression in progress {progressZip}%
                </div>
              </div>
            ) : progressZip == 100 ? (
              <div className="disabledbutton">
                <ul>{thumbs}</ul>
              </div>
            ) : (
              <ul>{thumbs}</ul>
            )}
          </aside>
          {(progressZip > 0 && progressZip != 100) ||
          (progressFirebase > 0 && progressFirebase != 100) ? (
            <div className="disabledbutton">
              <InnerDropzone
                files={files}
                unique_id={unique_id}
                setFiles={setFiles}
                progress={progressFirebase}
              />
            </div>
          ) : (
            <InnerDropzone
              files={files}
              unique_id={unique_id}
              setFiles={setFiles}
              progress={progressFirebase}
            />
          )}
        </div>
      </div>

      <div style={{ textAlign: "center", padding: "20px 0" }}>
        <Button
          icon="updated"
          onClick={() => uploadFile()}
          large={true}
          intent={"primary"}
          disabled={
            !files.length > 0 || progressFirebase > 0 || progressZip > 0
              ? true
              : false
          }
        >
          UPLOAD FILE
        </Button>
      </div>
    </section>
  );
}

export default Dropzone;
